import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=4e09c6c3&scoped=true&"
import script from "./article-list.vue?vue&type=script&lang=js&"
export * from "./article-list.vue?vue&type=script&lang=js&"
import style0 from "./article-list.vue?vue&type=style&index=0&id=4e09c6c3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09c6c3",
  null
  
)

export default component.exports